import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-chevron-up",
  "use": "n-icon-chevron-up-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"n-icon-chevron-up\">\n    <path d=\"M10 8.30168L5.64021 11.7682C5.21593 12.1218 4.58537 12.0644 4.2318 11.6402C3.87824 11.2159 3.93556 10.5853 4.35984 10.2318L9.35984 6.23175C9.73069 5.92272 10.2694 5.92272 10.6402 6.23175L15.6402 10.2318C16.0645 10.5853 16.1218 11.2159 15.7682 11.6402C15.4147 12.0644 14.7841 12.1218 14.3598 11.7682L10 8.30168Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol